import React from 'react';
import {
  BooleanField,
  Filter,
  NumberField,
  ShowButton,
  TextField,
} from 'react-admin';

import { IDSearch } from '../../reusable/IDSearch';
import ClipboardField from '../components/ClipboardField';
import InfiniteList from '../components/InfiniteList';
import { WriteOnlyDatagrid } from '../components/WriteOnlyDatagrid';
import { WriteOnlyEditButton } from '../components/WriteOnlyEditButton';

const NotificationOptionFilters: React.FC = (props) => (
  <Filter {...props}>
    <IDSearch label="Name" source="name" alwaysOn />
  </Filter>
);

export const NotificationOptionList: React.FC = () => (
  <InfiniteList filters={<NotificationOptionFilters />} perPage={20}>
    <WriteOnlyDatagrid bulkActionButtons={false}>
      <ClipboardField source="id" sortable={false} />
      <TextField source="name" sortable={false} />
      <TextField source="description" sortable={false} />
      <NumberField source="position" sortable={false} />
      <BooleanField source="visible" sortable={false} />
      <TextField source="value" sortable={false} />
      <WriteOnlyEditButton />
      <ShowButton />
    </WriteOnlyDatagrid>
  </InfiniteList>
);
